var map = {
	"./demerara.png": "cb35",
	"./dulcita.png": "0399",
	"./fior-di-cocco.png": "4986",
	"./manduvira.png": "9b5a",
	"./mascobado.png": "7ae9",
	"./picaflor.png": "7e35"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e7a9";